<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel isActive="true">
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-autocomplete 
                v-bind:items="branches" 
                v-model="selectedBranch"
                return-object
                
                item-text="name" 
                label="Υποκατάστημα"
                clearable>
              </v-autocomplete>
            </v-col>
              
            
        </v-row>


          <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="success" 
                @click="getData" 
                v-bind:loading="getDataButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                class="mx-2"
                color="warning" 
                @click="clearFilters" 
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>

        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :sort-by="['issue_date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-filtering>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Αποτελέσματα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <v-btn color="success" dark class="mb-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
            ΕΞΑΓΩΓΗ
          </v-btn>

        </v-toolbar>
      </template>
      
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>


      <template v-slot:[`item.debit`]="{ item }">
        {{ formatMoney(item.debit) }}
      </template>

      <template v-slot:[`item.credit`]="{ item }">
        {{ formatMoney(item.credit) }}
      </template>

      <template v-slot:[`item.oldBalance`]="{ item }">
        {{ formatMoney(item.oldBalance) }}
      </template>

      <template v-slot:[`item.newBalance`]="{ item }">
        {{ formatMoney(item.newBalance) }}
      </template>

      <template slot="body.append" v-if="showExport">
        <tr>
            <th>Σύνολα</th>
            <th></th>
            <th >{{totalsSum('plithos_parastatikon')}}</th> 
            <th class="text-right">{{totalsSum('quantity', 2)}}</th>
            <th class="text-right">{{totalsSum('without_vat', 2)}}</th>
            <th class="text-right">{{totalsSum('with_vat', 2)}}</th>
        </tr>
      </template>

    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      allerrors : {
        
      },

      dialog: false,

      branches: [],

      headers: [
        { 
            text: 'Ημερομηνία', 
            align: 'left',
            value: 'issue_date',
            exportTransformer: (cell) => moment(cell).format("DD/MM/YYYY")
        },
        { 
            text: 'Υποκατάστημα', 
            align: 'left',
            value: 'branch_name' 
        },
        { 
            text: 'Πλήθος παραστατικών', 
            align: 'left',
            value: 'plithos_parastatikon' 
        },
        { 
          text: 'Ποσότητα', 
          align: 'right',
          value: 'quantity',
          exportTransformer: (cell) => cell.replace('.', ',')   
        },
        { 
          text: 'Χωρίς ΦΠΑ', 
          align: 'right',
          value: 'without_vat',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Με ΦΠΑ', 
          align: 'right',
          value: 'with_vat',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },

      ],

      items: [],


      documentTypes: [],
      accounts: [],

      selectedAccount: {},

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,
      selectedBranch: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      },

      totalsCount() {
        return this.items?.length    
      }
    },

    methods: {

      totalsSum(fieldName, fixDecimals)
      {


        const sum = this.items?.map(x => parseFloat(x[fieldName])).reduce((a, b) => a + b, 0)

        if (fixDecimals > 0)
          return sum.toFixed(2)

        return parseInt(sum)

      },

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        this.documentIssueDateStopFilter = this.$localDateString(today)

        

        // this.getData();
        this.getFilterValues()
      },

      async getFilterValues() {
        const response = await axios.get('/api/company')
        this.branches = response.data.branches
      },
      
      getRequestParams() {
        let out = {
          
        }


        if (this.documentIssueDateStartFilter != null)
          out.issue_date_start = this.documentIssueDateStartFilter

        if (this.documentIssueDateStopFilter != null)
          out.issue_date_stop = this.documentIssueDateStopFilter

        if (this.selectedBranch != null)
          out.branch_id = this.selectedBranch.id
        
        return out
      },

      getData() {
        this.allerrors = {}

        const params = this.getRequestParams()

        if (params.issue_date_start == null || params.issue_date_stop == null)
          return


        this.getDataButtonDisabled = true;
        axios.post(
            '/api/reports/sales-per-day', 
            {
                params: params
            }
        )
        .then(response => this.items = response.data)
        .finally(() => { this.getDataButtonDisabled = false; })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
      }
    }
  }
</script>

<style scoped>
</style>